export const styles = {
  address: {
      color: "white",
      fontSize: 11,
        margin: [0, 35, 40, 0]
  },
  alignRight: {
        alignment: "right",
    },
    billToColumn: {
      margin: [0, 0, 50, 0],
    },
    contactInfo: {
        color: "white",
        fontSize: 11,
        margin: [0, 35, 30, 0]
    },
    grandTotalsText: {
      alignment: "right",
      fontSize: 14,
      bold: true,
      margin: [0, 5, 0, 0]
    },
    grandTotalsLabel: {
        color: "#8493a3",
        fontSize: 14,
        bold: true,
        margin: [0, 5, 30, 0]
    },
    header: {
        margin: [-40,-40,-40,0],
        fillColor: "#8493a3",
    },
    headerTitle: {
        color: 'white',
        alignment: 'center',
        fontSize: 40,
        bold: true,
        margin: [40, 30, 0, 0]
    },
    infoHeaderText: {
      color: "#8493a3",
      margin: [0, 0, 0, 5]
    },
    infoSubheaderText: {
        color: "#8493a3",
        margin: [0, 5, 0, 5]
    },
    invoiceInfo: {
        margin: [0, 30, 0, 0]
    },
    invoiceNumberColumn: {
        margin: [0, 0, 50, 0],
    },
    invoiceTotalColumn: {
        alignment: "right",
        margin: [0, 0, 0, 0],
    },
    lineItems: {
      margin: [10, 10, 10, 10]
    },
    tableHeaderNumber: {
        alignment: "right",
        color: "#8493a3",
        margin: [0, 10, 0, 10]
    },
    tableHeaderText: {
        color: "#8493a3",
        margin: [0, 10, 0, 10]
    },
    summary: {
        margin: [0, 40, 0, 0]
    },
    totalsText: {
        alignment: "right",
        margin: [0, 5, 0, 0]
    },
    totalsLabel: {
        color: "#8493a3",
        margin: [0, 5, 30, 0]
    }
}



// WEBPACK FOOTER //
// ./src/store/generators/PDF/invoice/styles.js